import interceptor from "@/plugins/interceptor";
const pathController = '/Home'

export default {
    state: () => ({}),
    mutations: {},
    actions: {
        async random_resources(){
            return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}/randomResources`)
        }
    }
}